import React from 'react';
import { Phone, Mail } from 'lucide-react';
import PortalService from '../../../services/portal/portal.service';
import { usePortalResource } from '../usePortalResource';
import PortalSection, { Card } from '../PortalSection';
import { FOCUS_RING } from '../format';

/** Contact agency: phone and email links only (FAM-13, no messaging). */
const ContactScreen: React.FC<{ patientId: string }> = ({ patientId }) => {
  const { data, loading, error } = usePortalResource(PortalService.getContact, patientId);
  const linkClass = `inline-flex min-h-11 items-center gap-2 rounded-md border border-slate-300 bg-white px-4 text-slate-900 hover:bg-slate-50 ${FOCUS_RING}`;
  return (
    <PortalSection title="Contact agency" loading={loading} error={error}>
      {data && (
        <Card>
          <h2 className="text-lg font-semibold text-slate-900">{data.agencyName}</h2>
          {data.officeHours && <p className="mt-1 text-sm text-slate-700">Office hours: {data.officeHours}</p>}
          <div className="mt-4 flex flex-col gap-3 sm:flex-row">
            {data.phone && (
              <a href={`tel:${data.phone}`} className={linkClass}>
                <Phone size={18} aria-hidden="true" />
                <span>Call {data.phone}</span>
              </a>
            )}
            {data.email && (
              <a href={`mailto:${data.email}`} className={linkClass}>
                <Mail size={18} aria-hidden="true" />
                <span>Email {data.email}</span>
              </a>
            )}
          </div>
          <p className="mt-4 text-sm text-slate-700">
            To request a change to the patient&apos;s record, call or email the agency.
          </p>
        </Card>
      )}
    </PortalSection>
  );
};

export default ContactScreen;
